import './src/variables.scss';
import './src/sweetalert2.scss';
import './ext/sweet-alert.ext.scss';
import './src/sweetalert2.js';
export default globalThis.Sweetalert2.mixin({});